import { atom, selectorFamily } from 'recoil';
import { InvoiceService } from 'api';
export const getInvoicesByAccountIdAndStatusPagination = atom({
  key: 'getInvoicesByAccountIdAndStatusPagination',
  default: {
    max: 1,
    // this is not to fetch unnecessary data in Agreement.tsx
    offset: 0
  }
});
export const getInvoicesByAccountIdAndStatus = selectorFamily({
  key: 'getInvoicesByAccountIdAndStatus',
  get: ({
    accountId,
    invoiceStatus
  }) => async ({
    get
  }) => {
    if (!accountId || !invoiceStatus) return {};
    const pagination = get(getInvoicesByAccountIdAndStatusPagination);
    const body = {
      ...pagination,
      accountId,
      invoiceStatus
    };
    const result = await InvoiceService.getInvoicesByAccountIdAndStatus({
      body
    });
    return result;
  }
});